/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/core';
import Edit from 'assets/edit.svg';

const EditMarker = () => (
	<div
		style={{
			position: 'absolute',
			right: 0,
			top: 0,
			width: 16,
			height: 16,
			margin: 0,
			padding: 0,
			background: `url(${Edit}) no-repeat`,
		}}
	/>
);

export default EditMarker;
